module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp1",
    attrs: {
      "id": "epig"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "EP"
  }, [_vm._v("Wherever you go, there are plenty of places where you will find a welcome; and if you choose to go to Thessaly, I have friends there who will make much of you and give you complete protection, so that no one in Thessaly can interfere with you.")]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("—")]), _vm._v("P"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("LATO")]), _vm._v(","), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v(" Crito")])]), _vm._v(" "), _c('p', {
    staticClass: "EP"
  }, [_vm._v("The triremes which defended Greece at Salamis defended Mars too.")]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("—")]), _vm._v("A"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("DA ")]), _vm._v("P"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ALMER, ")]), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Dogs of Peace")])]), _vm._v(" "), _c('p', {
    staticClass: "EP"
  }, [_vm._v("Yes, I know, Plato; but if you always take the steps in threes, one day you will miss a cracked one.")]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("—")]), _vm._v("M"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ARY ")]), _vm._v("R"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ENAULT, ")]), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Last of the Wine")])]), _vm._v(" "), _c('p', {
    staticClass: "EP-V"
  }, [_vm._v("If you could take that first step")]), _vm._v(" "), _c('p', {
    staticClass: "EP-V"
  }, [_vm._v("You could dance with Artemis")]), _vm._v(" "), _c('p', {
    staticClass: "EP-V-S"
  }, [_vm._v("Beside Apollo Eleven.")]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("—")]), _vm._v("J"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("O ")]), _vm._v("W"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ALTON,")]), _c('span', {
    staticClass: "epc-r"
  }, [_vm._v(" “Submersible Moonphase”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21679962","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0